import React, { useEffect } from "react";

import CardIcon from "../../components/CardIcon/CardIcon";
import DarkMode from "../../components/DarkMode/DarkMode";

import "./Skills.css";

const dataIcon = [
	{
		name: "HTML",
		icon: "ion:logo-html5",
		color: "#E44D26",
	},
	{
		name: "CSS",
		icon: "ion:logo-css3",
		color: "#0096DC",
	},
	{
		name: "Javascript",
		icon: "ion:logo-javascript",
		color: "#DAB92D",
	},
	{
		name: "Bootstrap",
		icon: "fa-brands:bootstrap",
		color: "#7F12F9",
	},
	{
		name: "React",
		icon: "ion:logo-react",
		color: "#61DAFB",
	},
	{
		name: "PHP",
		icon: "simple-icons:php",
		color: "#777BB3",
	},
	{
		name: "Laravel",
		icon: "fa-brands:laravel",
		color: "#EF3A2E",
	},
	{
		name: "Codeigniter",
		icon: "simple-icons:codeigniter",
		color: "#FF4E1B",
	},
	{
		name: "NodeJs",
		icon: "ion:logo-nodejs",
		color: "#90C53F",
	},
	{
		name: "Golang",
		icon: "fa6-brands:golang",
		color: "#00ADD9",
	},
	{
		name: "SQL DB",
		icon: "mdi:sql-query",
	},
	{
		name: "Firebase",
		icon: "ion:logo-firebase",
		color: "#FFA611",
	},
	{
		name: "GCP",
		icon: "bxl:google-cloud",
		color: "#FFA611",
	},
	{
		name: "AWS",
		icon: "bxl:aws",
	},
];

const Skills = () => {
	useEffect(() => {
		document.title = "Maish | Skills";
	}, []);

	return (
		<section id="main" className="skills-main">
			<DarkMode />
			<div className="container-fluid-skill">
				<div className="text-center" id="skills">
					<h1 className="title-skills yellow">My Skills</h1>
					<CardIcon listItems={dataIcon} />
				</div>
			</div>
		</section>
	);
};

export default Skills;
